import React, { FunctionComponent } from 'react';

const IndicationMessage: FunctionComponent = ({ children }) => (
  <div className="indication-message">
    {children}
  </div>
);

export default IndicationMessage;
